import { atom } from 'recoil';
import { PaymentInfoType } from '@/types/api/mypage/paymentInfo';
import persistAtom from './recoilPersist';

/**
 * 現在の支払い方法情報を保持する state。
 * 契約情報画面と支払方法変更画面の両方から参照するため、取得済み情報を単一 state に集約する。
 */
export const PaymentInfoState = atom<PaymentInfoType>({
  key: 'PaymentInfoState',
  default: {
    bl_id: '',
    payment_type: '',
  },
  effects_UNSTABLE: [persistAtom],
});

/**
 * 支払方法変更画面で現在選択中の決済手段を保持する state。
 * 確認画面との往復や別決済画面への遷移でも選択状態を維持するために使う。
 */
export const PaymentMethodState = atom<string>({
  key: 'PaymentMethodState',
  default: '',
  effects_UNSTABLE: [persistAtom],
});

export default PaymentMethodState;
